/**
 * Money, percent, and multiple formatters — the shared Utils home
 * (PLAT-UTILS-1 R3). Moved verbatim from `pages/valuation/_shared.tsx`;
 * behavior is unchanged, only the location moved.
 *
 * These are generic number-formatting helpers with no Valuation-specific
 * meaning — any product may import them. Domain-meaning code (status
 * labels, value-kind labels) stays product-local; see `_shared.tsx`.
 */

export function money(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—'
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  })
}

/**
 * Rates in this product are PERCENT-SCALE, not fractions — `core/valuation`
 * signs 4.35 to mean 4.35%, and `discount_rate.py` / `income_approach.py`
 * divide by 100 themselves. So this formats, it does not convert.
 */
export function pct(value: number | null | undefined, digits = 2): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—'
  return `${value.toFixed(digits)}%`
}

/** For the genuinely fractional values — triangulation weights (0.60 → 60%). */
export function fracPct(value: number | null | undefined, digits = 0): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—'
  return `${(value * 100).toFixed(digits)}%`
}

export function multiple(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—'
  return `${value.toFixed(2)}x`
}
